import GalleryList from "~/components/GalleryList";
import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

export default function GalleryActionPage() {
	useSeo({
		title: trans("skelet.title.action"),
		canonical: "galerie-akce",
	});

	const pageData = mainStore(state => state.data.pageData);
	const source = pageData.photos.action;

	return <GalleryList baseUrl={getLink(ROUTES.galleryAction)} title={trans("template.action")} source={source} />;
}
